import axios from "axios";

export const updateConversation = async (
  conversationId: string,
  payload: { system_prompt: string }
) => {
  try {
    const accessToken = localStorage.getItem("accessToken");
    const response = await axios.put(
      `${import.meta.env.VITE_API_URL}/conversation/${conversationId}`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("API error:", error);
    throw error;
  }
};
